import { ReactComponent as SVGClose24 } from "assets/close24.svg";
import { SignUpButton } from "components/SignUpButton";
import {
  closeDrawer,
  selectIsDrawerOpened,
} from "features/NavigationDrawer/slice";
import React from "react";
import { NavLink } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import styled from "styled-components/macro";
import { HEADER_HEIGHT, NAVIGATION_DRAWER_Z_INDEX } from "styles/constants";

const NAVIGATION_PADDING_LEFT = 26;

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  background-color: ${({ theme }) => theme.background};
  z-index: ${NAVIGATION_DRAWER_Z_INDEX};
`;

const NavigationHeader = styled.header`
  display: flex;
  height: ${HEADER_HEIGHT}px;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 0 ${NAVIGATION_PADDING_LEFT}px;
`;

const LogoWrapper = styled.div``;

const CloseButton = styled.button`
  display: flex;
  width: 24px;
  height: 24px;
`;

const UL = styled.ul`
  padding-left: ${NAVIGATION_PADDING_LEFT}px;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  height: 56px;
`;

const StyledNavLink = styled(NavLink)`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
`;

export function NavigationDrawer() {
  const dispatch = useAppDispatch();
  const isOpened = useAppSelector(selectIsDrawerOpened);

  if (!isOpened) {
    return null;
  }

  return (
    <Wrapper>
      <NavigationHeader>
        <LogoWrapper></LogoWrapper>
        <CloseButton type="button" onClick={() => dispatch(closeDrawer())}>
          <SVGClose24 />
        </CloseButton>
      </NavigationHeader>
      <UL>
        <ListItem>
          <StyledNavLink to="/product" onClick={() => dispatch(closeDrawer())}>
            Product
          </StyledNavLink>
        </ListItem>
        <ListItem>
          <StyledNavLink to="/about" onClick={() => dispatch(closeDrawer())}>
            About
          </StyledNavLink>
        </ListItem>
        <ListItem>
          <StyledNavLink to="/signin" onClick={() => dispatch(closeDrawer())}>
            Sign in
          </StyledNavLink>
        </ListItem>
        <ListItem>
          <SignUpButton onClick={() => dispatch(closeDrawer())} />
        </ListItem>
      </UL>
    </Wrapper>
  );
}
